import YearlyAgreement36Page from './YearlyAgreement36Page';

export default YearlyAgreement36Page;
